export const N8Schema = {
    terminationDate: [
        { rule: "required", message: "Date required" },
    ],
    details1: [
        { rule: "required", message: "required" },
    ],
    
    firstName: [
        { rule: "required", message: "first name required" },
    ], 
    lastName: [
        { rule: "required", message: "last name required" },
    ], 
    signingDate: [
        { rule: "required", message: "signing date required" },
    ], 
}